export default "__VITE_ASSET__3v7zu7wW__";